import React, { useEffect } from "react";
import features from "../../constants/features";
import "aos/dist/aos.css";
import AOS from "aos";

const Features = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-full h-full flex box-border p-8 py-16 bg-gray-50 rounded-3xl my-12">
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="w-full text-center mb-12">
          <h2
            className="text-3xl md:text-5xl mt-5 text-center font-mazzardbold bg-clip-text text-transparent bg-gradient-to-r from-black to-blue-900"
            data-aos="fade-up"
          >
            Features
          </h2>
          <p
            className="text-gray-600 mt-4 max-w-2xl mx-auto"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Discover why Fusion Cab is revolutionizing the cab rental industry
            with our innovative features
          </p>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          style={{
            maxWidth: "1200px",
            width: "100%",
          }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group"
            >
              <div
                className={`${
                  feature.color === "blue"
                    ? "bg-gradient-to-br from-blue-500 to-blue-700"
                    : "bg-gradient-to-br from-gray-800 to-black"
                } w-full shadow-lg rounded-2xl p-6 flex justify-center items-center aspect-square mb-4 transition-all duration-300 transform group-hover:-translate-y-2 group-hover:shadow-xl relative overflow-hidden`}
              >
                <div className="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-30 bg-white transition-opacity duration-300"></div>
                <img
                  src={feature.icon}
                  alt={feature.name}
                  className="w-20 h-20 object-contain z-10"
                />
              </div>
              <div className="text-xl font-mazzardbold text-left w-full mb-2 text-gray-900 group-hover:text-blue-900 transition-colors duration-300">
                {feature.name}
              </div>
              <div className="text-sm text-left w-full text-gray-600 leading-relaxed">
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
